import { MinusCircleIcon } from "@heroicons/react/24/outline";
import { useMemo, useState } from "react";
import { DateValueType } from "react-tailwindcss-datepicker";
import { EmptyList } from "src/components/EmptyList";
import Loading from "src/components/Loading";
import SortIcon from "src/components/ui-icons/table/SortIcon";
import { TableHeaderColumnProps } from "src/components/ui/table/Table";
import { TaskItem } from "src/modules/checklistTasks";
import { FlexCol, FlexRow } from "src/utils/flexLayouts";
import { twMerge } from "tailwind-merge";

type TableHeadType =
  | "Direction"
  | "Period"
  | "Task"
  | "CompletionCriteria"
  | "PointOfDone"
  | "PointOfDeviation"
  | "Actions"
  | "Test";

const tableHeaderContent: Record<TableHeadType, any> = {
  Direction: {
    title: "Направление",
    sort: false,
    style: { width: "10%" },
  },
  Period: {
    title: "Периодичность",
    sort: true,
    style: { width: "10%" },
  },
  Task: {
    title: "Задача",
    sort: false,
    style: { width: "32%" },
  },
  CompletionCriteria: {
    title: "Критерий выполнения",
    sort: false,
    style: { width: "8%" },
  },
  PointOfDone: {
    title: "Отметка о выполнении",
    sort: false,
    style: { width: "10%" },
  },
  PointOfDeviation: {
    title: "Отметка об отклонении",
    sort: false,
    style: { width: "10%" },
  },
  Actions: {
    title: "Действия",
    sort: false,
    style: { width: "10%" },
  },
  Test: {
    title: "Опросник",
    sort: false,
    style: { width: "10%" },
  },
};

function MyTaskCheckListMyTeamTable({
  items,
  loading,
  cb,
  periodDate,
  onOpenTask,
}: {
  items: TaskItem[];
  loading: boolean;
  cb: any;
  periodDate: DateValueType;
  onOpenTask?: (connectionId: number) => void;
}) {
  return (
    <Table
      tableName="Table with favorite documents"
      // count={favoriteItemsCount}
      // numberOfPages={numberOfPages}
      header={tableHeaderContent}
      body={items}
      cb={cb}
      // page={page}
      loading={loading}
      onChangePage={() => console.log("text")}
      onOpenTask={onOpenTask}
    />
  );
}

export default MyTaskCheckListMyTeamTable;

function Table({
  header,
  body,
  page,
  loading,
  count,
  numberOfPages,
  onChangePage,
  tableName,
  cb,
  onOpenTask,
}: {
  header: typeof tableHeaderContent;
  body: TaskItem[];
  loading: boolean;
  count?: number;
  page?: number;
  numberOfPages?: number;
  onChangePage: (page: number) => void;
  tableName: string;
  cb: any;
  onOpenTask?: (connectionId: number) => void;
}) {
  const [sortedField, setSortedField] = useState<TableHeadType | null>(null);
  const [sortDirection, setSortDirection] = useState<"asc" | "desc" | "default">("default");

  const handleSort = (field: TableHeadType) => {
    if (sortedField === field) {
      setSortDirection((prevDirection) =>
        prevDirection === "asc" ? "desc" : prevDirection === "desc" ? "default" : "asc",
      );
    } else {
      setSortedField(field);
      setSortDirection("asc");
    }
  };

  const sortedTableBodyContent = useMemo(() => {
    if (!sortedField || sortDirection === "default") {

      return body;
    }

    const sortedData = [...body];

    // sortedData.sort((a, b) => {
    //   if (a[sortedField] && b[sortedField]) {
    //     if (sortedField === "Document" && a[sortedField].Title && b[sortedField].Title) {
    //       return sortDirection === "asc"
    //         ? a[sortedField].Title.toLowerCase().localeCompare(b[sortedField].Title)
    //         : b[sortedField].Title.toLowerCase().localeCompare(a[sortedField].Title);
    //     }

    //     if (sortedField === "NotificationType") {
    //       return sortDirection === "asc"
    //         ? a[sortedField].ID - b[sortedField].ID
    //         : b[sortedField].ID - a[sortedField].ID;
    //     }

    //     if (sortedField === "Author" || sortedField === "Employee") {
    //       return sortDirection === "asc"
    //         ? a[sortedField].Name.localeCompare(b[sortedField].Name)
    //         : b[sortedField].Name.localeCompare(a[sortedField].Name);
    //     }

    //     const valueA = a[sortedField];
    //     const valueB = b[sortedField];

    //     if (isObject(valueA) && isString(valueA) && isString(valueB) && sortedField === "DocumentCode") {
    //       return sortDirection === "asc" ? valueA.localeCompare(valueB) : valueB.localeCompare(valueA);
    //     }

    //     if (typeof valueA === "string" && typeof valueB === "string") {
    //       return sortDirection === "asc" ? valueA.localeCompare(valueB) : valueB.localeCompare(valueA);
    //     } else if (typeof valueA === "boolean" && typeof valueB === "boolean") {
    //       return sortDirection === "asc" ? Number(valueA) - Number(valueB) : Number(valueB) - Number(valueA);
    //     } else if (moment.isMoment(valueA) && moment.isMoment(valueB)) {
    //       return sortDirection === "asc" ? valueA.unix() - valueB.unix() : valueB.unix() - valueA.unix();
    //     }
    //   }

    //   return 0;
    // });

    return sortedData;
  }, [sortedField, sortDirection, body]);

  return (
    <FlexCol className="w-full">
      <TableList
        head={header}
        body={sortedTableBodyContent}
        sort={handleSort}
        sortDirection={sortDirection}
        sortedField={sortedField}
        tableName={tableName}
        cb={cb}
        loading={loading}
        onOpenTask={onOpenTask}
      />
    </FlexCol>
  );
}

function TableList({
  head,
  body,
  sort,
  sortDirection,
  sortedField,
  loading,
  cb,
  onOpenTask,
}: {
  head: typeof tableHeaderContent;
  body: TaskItem[];
  sort: (f: TableHeadType) => void;
  sortedField: TableHeadType | null;
  sortDirection: "asc" | "desc" | "default";
  loading: boolean;
  tableName?: string;
  cb: any;
  onOpenTask?: (connectionId: number) => void;
}) {
  return (
    <div
      id="table-scroll"
      className={twMerge(
        "w-auto px-6 pb-5 overflow-x-auto bg-white rounded-lg table-custom shadow-custom scrollbar scrollbar-thumb-rounded-lg scrollbar-h-2 scrollbar-thumb-[#D1D5DB]",
        "max-h-[calc(100vh-156px)] max-h-[calc(100dvh-156px)]"
      )}
    >
      <FlexRow className="w-auto min-w-[930px]">
        <div className="flex flex-col min-w-[1235px] grow">
          <FlexRow className="top-0 z-10 gap-x-4 px-6 pt-5 pb-5 -mx-6 -mt-5 text-black bg-white border-b sticky-custom">
            {Object.keys(head).map((fieldKey) => {
              const key = fieldKey as TableHeadType;

              return (
                <TableHeaderColumn
                  key={fieldKey}
                  tableHeaderContent={head[key]}
                  sortDirection={sortedField === key ? sortDirection : "default"}
                  onClick={() => sort(key)}
                />
              );
            })}
          </FlexRow>
          <FlexRow className="mt-9">
            <FlexCol className="grow">
              {loading ? (
                <div className="pt-4">
                  <Loading />
                </div>
              ) : Array.isArray(body) && body.length > 0 ? (
                <div className="divide-y table-wrap">
                  {body.map((item, index) => (
                    <TableListItem item={item} key={index} onOpenTask={onOpenTask} />
                  ))}
                </div>
              ) : (
                <EmptyList icon={<MinusCircleIcon width={24} height={24} />} title="Нет задач" />
              )}
            </FlexCol>
          </FlexRow>
        </div>
      </FlexRow>
    </div>
  );
}

function TableListItem({ item, onOpenTask }: { item: TaskItem; onOpenTask?: (connectionId: number) => void }) {
  const hasDeviation = item.Result.hasDeviation;

  return (
    <FlexRow
      className={twMerge(
        "py-4 rounded-lg cursor-pointer gap-x-4 -mx-2 px-2",
        !hasDeviation && "hover:bg-[#F3F4F6] hover:bg-opacity-50",
      )}
      style={hasDeviation ? { backgroundColor: "rgba(255, 0, 122, 0.1)" } : undefined}
      key={item.ID}
      onClick={() => {
        if (onOpenTask) {
          onOpenTask(Number(item.ConnectionID));
        }
      }}
    >
      <FlexCol className="break-words text-[#637381]" style={{ width: "10%" }}>
        {`${item.Direction}`}
      </FlexCol>
      <FlexCol className="break-words text-darkblue" style={{ width: "10%" }}>
        {item.Period}
      </FlexCol>
      <FlexCol className="break-words text-[#637381]" style={{ width: "32%" }}>
        <FlexRow className="text-[14px] text-darkblue">{item.Task.Title}</FlexRow>
        <FlexRow className="text-[12px] whitespace-pre-line">{item.Task.Description}</FlexRow>
      </FlexCol>
      <FlexCol className="break-words text-[#637381] whitespace-pre-line" style={{ width: "8%" }}>
        {item.Task.CompletionCriteria}
      </FlexCol>
      <FlexCol className="break-words text-[#637381] gap-y-2.5" style={{ width: "10%" }}>
        {item.Result.isDone ? "Выполнено" : "Не выполнено"}
      </FlexCol>
      <FlexCol className="break-words text-[#637381] gap-y-2.5" style={{ width: "10%" }}>
        {item.Result.hasDeviation ? "Выявлено отклонение" : "---"}
      </FlexCol>
      <FlexCol className="break-words text-[#637381] gap-y-2.5" style={{ width: "10%" }}>
        Создано: {item.countActions}
      </FlexCol>
      <FlexCol className="break-words text-[#637381] gap-y-2.5" style={{ width: "10%" }}>
        {item.PassTest}
      </FlexCol>
    </FlexRow>
  );
}

export function TableHeaderColumn({ tableHeaderContent, sortDirection, onClick }: TableHeaderColumnProps) {
  return (
    <FlexCol className="select-none" style={tableHeaderContent.style}>
      <FlexRow className="gap-x-2 items-center">
        {tableHeaderContent.icon && <FlexCol>{tableHeaderContent.icon}</FlexCol>}
        <FlexCol className="font-medium whitespace-pre-line w-fit">{tableHeaderContent.title}</FlexCol>
        {tableHeaderContent.sort && (
          <FlexCol className="w-auto cursor-pointer" onClick={onClick}>
            <SortIcon sortDirection={sortDirection} />
          </FlexCol>
        )}
      </FlexRow>
    </FlexCol>
  );
}
